import * as React from 'react';

function CheckmarkIcon(props) {
	return (
		<svg width={15} height={15} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path d='M14.56 7.28A7.284 7.284 0 0 0 7.28 0 7.284 7.284 0 0 0 0 7.28a7.284 7.284 0 0 0 7.28 7.28 7.284 7.284 0 0 0 7.28-7.28Zm-13.367 0a6.087 6.087 0 1 1 12.173 0 6.087 6.087 0 0 1-12.173 0Z' fill='#153c4f' />
			<path d='M10.96 5.109a.605.605 0 0 0-.855-.02L6.52 8.5a.164.164 0 0 1-.23-.003L4.457 6.661a.59.59 0 0 0-.835.835l2.366 2.367c.12.12.279.18.418.18.14 0 .298-.06.418-.16l4.116-3.918a.605.605 0 0 0 .02-.856Z' fill='#153c4f' />
		</svg>
	);
}

export default CheckmarkIcon;
